/**
 * Created by Alex Aguilar on 6/23/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('baseRatesCtrl', baseRatesCtrl)
        .controller('baseRateEditCtrl', baseRateEditCtrl);

    baseRatesCtrl.$inject = ['linkService','baseRates'];
    baseRateEditCtrl.$inject = ['baseRateService', '$stateParams','baseRate'];

    function baseRatesCtrl(linkService,baseRates){
        var vm = this;
        vm.linkService = linkService;

        vm.baseRates = (baseRates.data._embedded) ? baseRates.data._embedded.baserates : [];
        vm.pages = baseRates.data.page;
        vm.searchRecords = "";
    }

    function baseRateEditCtrl(baseRateService, $stateParams, baseRate){
        var vm = this;
        vm.baseRate = baseRate.data;

        vm.saveBaseRate = function(isValid, baseRate){
            if(isValid){
                baseRateService.updateBaseRate($stateParams.id, baseRate, 'baseRates');
            }
        }
    }
})();
